import { Breadcrumbs, Typography } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { displayAdvancedRequestName } from "../../common/util/DisplayUtil";

export default function AdvancedRequestsBreadcrumbs({
  selectedRequest,
  adminView = false,
}) {
  const navigate = useNavigate();
  return (
    <Breadcrumbs aria-label="product request breadcrumb">
      {selectedRequest ? (
        <Link
          to={
            adminView
              ? "/app/business-admin/manage-requests"
              : "/app/buyer/view-orders"
          }
          onClick={(e) => {
            if (adminView) {
              e.preventDefault();
              // Go back to the last page to keep request search criteria (unless there is no page to go back to)
              if (window.history?.length && window.history.length > 1) {
                navigate(-1);
              } else {
                navigate("/app/business-admin/manage-requests");
              }
            }
          }}
        >
          Product Requests
        </Link>
      ) : (
        <Typography color="textPrimary">Product Requests</Typography>
      )}
      {selectedRequest && (
        <Typography color="text.primary">
          {displayAdvancedRequestName(selectedRequest)}
        </Typography>
      )}
    </Breadcrumbs>
  );
}
